import type { ComponentProps } from 'react';

import { Button } from '@repo/ui/components/common';
import { cn } from '@repo/utils/common';

interface MachineGroupCardButtonProps extends ComponentProps<typeof Button> {
  isSelected?: boolean;
  isActive?: boolean;
}

export const MachineGroupCardButton = ({
  className,
  children,
  isSelected,
  isActive,
  ...props
}: MachineGroupCardButtonProps) => {
  return (
    <Button
      className={cn(
        'border-2 bg-transparent font-medium',
        {
          'border-white text-white hover:bg-white hover:text-red-600 focus-visible:border-2 focus-visible:border-white focus-visible:ring-4 focus-visible:ring-white/50':
            isSelected,
          'border-primary text-primary hover:bg-primary hover:text-white': !isSelected,
          'text-primary border-white bg-white': isActive,
        },
        className,
      )}
      {...props}
      variant="outline"
      size="sm"
      type="button"
      aria-pressed={isSelected}
    >
      {children}
    </Button>
  );
};
